export default __webpack_public_path__ + "21f749e28b6a3f4b9d618a7395917f96.png";